<template>
<div>
    <header>
        <h1>Spiele veranstalten</h1>
    </header>
    <section>
        <div class="choice form-group">
            <a href="#" @click.prevent="type = 'match'" v-bind:class="{ 'btn-secondary': type == 'match' }">
                Freies Spiel
            </a>
            <a href="#" @click.prevent="type = 'tournament'" v-bind:class="{ 'btn-secondary': type == 'tournament' }">
                Turnier
            </a>
        </div>

        <custom-form v-if="type == 'match'"
                     :fields="[
                        { name: 'opponent', title: 'Gegner', type: 'user', placeholder: 'Gegner suchen', userType: 'community', extractId: true },
                        { name: 'num_games', title: 'Best of', type: 'toggle', choices: { 1:1, 3:3, 5:5, 7:7 } },
                     ]"
                     v-model="match"
                     submitLabel="Erstellen" 
                     url="match/create"
                     @input="onMatchInput"
                     @submitted="onMatchCreated" />

        <custom-form v-else
                     :fields="[
                        { name: 'name', type: 'text', title: 'Name' },
                        { name: 'invitees', title: 'Einladungen', type: 'user', userType: 'community', multiple: true, extractId: true },
                        { name: 'num_players', title: 'Teilnehmer', type: 'number', min: 3 },
                        { name: 'num_games', title: 'Best of', type: 'toggle', choices: { 1:1, 3:3, 5:5, 7:7 } },
                      ]"
                      v-model="tournament"
                      submitLabel="Erstellen"
                      url="tournament/create"
                      @submitted="onTournamentCreated" />
    </section>

    <section v-if="type == 'match' && match.opponent">
        <div class="form-group">
            <label>Elo-Vergleich</label>
            <elo-chart :matches="matches_me" :matchesB="matches_other" 
                       :userId="user.id" :userBId="match.opponent.id" />
        </div>
    </section>
</div>
</template>

<script>
import customForm from 'components/custom-form.vue'
import eloChart from 'components/elo-chart.vue'
import toggle from 'components/toggle.vue'
import _ from 'underscore'
import base from 'base.vue'

export default {
    mixins: [ base ],
    components: { customForm, eloChart, toggle },
    data () {
        return {
            match: { num_games: 3 },
            tournament: { 
                name: 'Turnier von ' + window.store.state.user.firstname,
                num_games: 3,
                num_players: 4,
                invitees: [ window.store.state.user ]
            },
            prev_opponent: null,
            type: 'match',
            matches_me: [],
            matches_other: null
        }
    },
    methods: {
        onMatchCreated () {
            window.router.push('/')
        },
        onTournamentCreated () {
            window.router.push('/tournaments')
        },
        fetchData () {
            const that = this

            return this.$api.get('user/' + this.user.id + '/match/all')
            .then(response => {
                that.matches_me = _.filter(response.data, m => {
                    return m.status == 'completed'
                })
            })
        },
        onMatchInput (value) {
            if (this.match.opponent != this.prev_opponent) {
                this.prev_opponent = this.match.opponent

                const that = this
                this.$api.get('user/' + this.match.opponent.id + '/match/all')
                .then(response => {
                    that.matches_other = _.filter(response.data, m => {
                        return m.status == 'completed'
                    })
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// match.vue?566f2e8a